import React from 'react';
import Icon from '../../../components/AppIcon';

const ServiceTypeCard = ({
  service,
  isSelected,
  onSelect,
  disabled = false,
  warningMessage = null,
  kpbLevel,
  onKpbChange,
  kpbMaster
}) => {
  return (
    <div
      className={`w-full rounded-xl border-2 transition-all duration-300 text-left
        ${
          isSelected
            ? 'border-primary bg-primary/5 shadow-honda-subtle'
            : 'border-border bg-card hover:border-primary/50 hover:shadow-md'
        }
        ${disabled ? 'opacity-50 cursor-not-allowed' : ''}
      `}
    >
      {/* === CLICKABLE HEADER === */}
      <div
        onClick={() => {
          if (!disabled) onSelect(service?.id);
        }}
        className="p-4 md:p-6 cursor-pointer"
      >
        <div className="flex items-start space-x-4">
          {/* ICON */}
          <div
            className={`w-12 h-12 md:w-14 md:h-14 rounded-lg flex items-center justify-center flex-shrink-0
              ${isSelected ? 'bg-primary' : 'bg-muted'}
            `}
          >
            <Icon
              name={service?.icon}
              size={24}
              color={isSelected ? 'white' : 'var(--color-foreground)'}
            />
          </div>

          {/* MAIN INFO */}
          <div className="flex-1">
            <h3 className="text-base md:text-lg font-heading font-bold text-foreground mb-1">
              {service?.name}
            </h3>

            <p className="text-sm text-muted-foreground mb-2">
              {service?.description}
            </p>

            <div className="flex items-center gap-4 text-xs md:text-sm">
              <div className="flex items-center gap-1 text-muted-foreground">
                <Icon name="Clock" size={14} />
                <span>{service?.duration}</span>
              </div>

              <div className="font-semibold text-primary">
                {service?.type === 'KPB' ? 'Gratis' : 'Berbayar'}
              </div>
            </div>

            {warningMessage && (
              <p className="mt-2 text-xs text-red-500 font-medium">
                {warningMessage}
              </p>
            )}
          </div>

          {/* CHECK */}
          <div
            className={`w-5 h-5 md:w-6 md:h-6 rounded-full border-2 flex items-center justify-center
              ${isSelected ? 'border-primary bg-primary' : 'border-muted-foreground'}
            `}
          >
            {isSelected && <Icon name="Check" size={14} color="white" />}
          </div>
        </div>
      </div>

      {/* === KPB DETAIL AREA (OUTSIDE CLICK AREA) === */}
      {service?.type === 'KPB' && isSelected && !disabled && (
        <div className="border-t border-border px-4 md:px-6 py-4 space-y-4">
          {/* DROPDOWN */}
          <div>
            <label className="block text-xs font-semibold mb-2">
              Pilih Jenis KPB
            </label>
            <select
              value={kpbLevel || ''}
              onChange={(e) => onKpbChange(e.target.value)}
              className="w-full px-3 py-2 rounded-lg border border-border bg-background text-sm
                focus:outline-none focus:ring-2 focus:ring-primary"
            >
              <option value="">-- Pilih KPB --</option>
              <option value="I">KPB I</option>
              <option value="II">KPB II</option>
              <option value="III">KPB III</option>
              <option value="IV">KPB IV</option>
            </select>
          </div>

          {/* DETAIL */}
          {kpbLevel && kpbMaster?.[service.category]?.[kpbLevel] && (
            <div className="rounded-lg bg-muted/40 border border-border p-4">
              {(() => {
                const data = kpbMaster[service.category][kpbLevel];

                return (
                  <>
                    <h4 className="text-sm font-heading font-bold mb-2">
                      Detail KPB {kpbLevel}
                    </h4>

                    <p className="text-xs text-muted-foreground mb-2">
                      <strong>Interval:</strong> {data.interval}
                    </p>

                    <ul className="text-xs space-y-1 mb-2">
                      {data.free.map((item, idx) => (
                        <li key={idx} className="flex gap-2">
                          <span className="text-success">✔</span>
                          {item}
                        </li>
                      ))}
                    </ul>

                    {data.estimate.length > 0 && (
                      <p className="text-xs text-muted-foreground">
                        <strong>Estimasi (jika diperlukan):</strong>{' '}
                        {data.estimate.join(', ')}
                      </p>
                    )}

                    <p className="text-[11px] text-muted-foreground italic mt-2">
                      {data.notes}
                    </p>
                  </>
                );
              })()}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ServiceTypeCard;
